export const locale = {
    lang: 'pt',
    data: {
        ORDER_CLINIC_MESSAGE: {
            TITLE: 'Chat',
            EMPTY: 'Nenhuma mensagem',
            ORDER_FINISHED: 'Pedido finalizado',
            ERROR_USER_LOGGED_EQUAL_CUSTOMER: 'Não é permitido enviar mensagem para você mesmo',
            FORM: {
                FIELDS: {
                    MESSAGE: 'Digite sua mensagem',
                },
            },
            MAT_MENU: {
                FILES: 'Arquivos',
                PHOTOS_AND_VIDEOS: 'Fotos e vídeos',
            },
            TOASTR: {
                ERRORS: {
                    PHOTO_VIDEO: 'É permitido apenas imagens ou vídeos.',
                    FILE: 'É permitido apenas arquivos diferentes de imagens ou vídeos.',
                    MAX_FILE: 'São permitidos no máximo 15 arquivos.',
                    MAX_FILE_SIZE: 'Não é permitido o envio de arquivos com mais de 150 MB.',
                },
            },
            MODAL: {
                GENERAL: {
                    BUTTONS: {
                        CONFIRM: 'Enviar',
                        CANCEL: 'Cancelar',
                    },
                },
                PREVIEW: {
                    TITLE: 'Pré-visualizar',
                },
                IMAGE: {
                    TITLE: 'Visualizar imagem',
                },
            },
            DROPZONE: {
                DESCRIPTION: 'Solte os arquivos para fazer upload',
            },
        },
    },
};
